import { notification } from 'antd';
import './notification.less';
import CheckBorderIcon from '../../assests/icons/check-border.icon';
import InfoBorderIcon from '../../assests/icons/info-border.icon';
import RejectBorderIcon from '../../assests/icons/rejected-border.icon';
import React, { useState } from 'react';
import InfoBorderNotification from 'assests/icons/info-border-notification.icon';

function Notification(placement, fileName, className, message, type = 'success', duration=10) {
  let icon ;
  switch(type) {
    case 'success':
      icon=<CheckBorderIcon />;
      break;
    case 'error':
      icon=<RejectBorderIcon />;
      break;
    case 'info':
      icon=<InfoBorderNotification />;
      break;
    default:
      icon=<InfoBorderNotification />;
  } 

  notification[type]({
    message: `"${fileName}" ${message}`,
    placement,
    className: `${className}`,
    duration: duration,
    icon: icon
  });
}

export default Notification;